import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailOrPhoneValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an Email
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;

    // Regular expression for validating a Phone number
    const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (emailRegex.test(value) || phoneRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidEmailOrPhone': true }; // Validation failed
    }
  };
}




export function debounce(callback:any, delay:number) {
  let timer:any
  return function() {
    clearTimeout(timer)
    timer = setTimeout(() => {
      callback();
    }, delay)
  }
}

export function pancardValidater(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating a Phone number
    const phoneRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (phoneRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidPanCard': true }; // Validation failed
    }
  };
}

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating a Phone number
    const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (phoneRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidPhone': true }; // Validation failed
    }
  };
}

export function phoneNumberRegex() {
  return /^(\+\d{1,3}[- ]?)?\d{10}$/;
}

export function customerSupportNumberRegex() {
  return /^(\+\d{1,3}[- ]?)?\d{10,15}$/;
}



export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    if(control.value.toString().length == 0) {
      return null
    }

    // Regular expression for validating an Email
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;


    if (emailRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidEmailOrPhone': true }; // Validation failed
    }
  };
}
export function emailRegex() {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
}


export function nameValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an Email
    const nameRegex = /^[a-zA-Z ]*$/;


    if (nameRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidString': true }; // Validation failed
    }
  };
}


export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an Email
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()-+=^])(?!.*\.{2})(?!.*\s).{8,20}$/;


    if (passwordRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidPassword': true }; // Validation failed
    }
  };
}


export const confirmPasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  return control.value.pwd === control.value.confirmPwd
    ? null
    : { PasswordNoMatch: true };
};


export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an url
    const urlRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;


    if (urlRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidUrl': true }; // Validation failed
    }
  };
}

export function urlRegex() {
  return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/
    ;
}

export function gstRegex() {
  return /^d{2}[A-Z]{5}\\\\d{4}[A-Z]{1}[A-Z\\\\d]{1}[Z]{1}[A-Z\\\\d]{1}$/;
}



export function pinCodeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an Email
    const pinRegex = /[0-9]{6}/;


    if (pinRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidUrl': true }; // Validation failed
    }
  };
}


export function gMapLinkValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // Regular expression for validating an Email
    const mapRegex = /https?:\/\/(www\.)?google\.com\/maps\/.*\/@(-?\d+(\.\d+)?),(-?\d+(\.\d+)?),\d+z\/?.*/;


    if (mapRegex.test(value)) {
      return null; // Validation passed
    } else {
      return { 'invalidUrl': true }; // Validation failed
    }
  };
}

export function gMapRegex() {
  return /https?:\/\/(www\.)?google\.com\/maps\/.*\/@(-?\d+(\.\d+)?),(-?\d+(\.\d+)?),\d+z\/?.*/;
}



export function expiryDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
      const expiryDateTogel = control.parent?.get('expiryDateTogel')?.value;
      const documentExpiryDate = control.value;

      // Return error object if expiryDateTogel is true and documentExpiryDate is not provided
      if (expiryDateTogel && !documentExpiryDate) {
          return { required: true };
      }

      // Return null if the control is valid
      return null;
  };
}


